import React, { useState, useEffect, useRef } from "react";

type Props = {
  children: React.ReactElement;
  option?: IntersectionObserverInit;
};
const ViewPortOnly = (props: Props) => {
  const [isOnviewport, setIsOnViewport] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  const { children, option } = props;

  const { threshold = [0.2], ...others } = option || {};

  useEffect(() => {
    const target = ref.current;
    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.target === target) {
          setIsOnViewport(entry.isIntersecting);
        }
      },
      { threshold, ...others }
    );

    observer.observe(target);

    return () => {
      observer.unobserve(target);
    };
  }, [threshold, others]);

  return <div ref={ref}>{React.cloneElement(children, { isOnviewport })}</div>;
};

export default ViewPortOnly;
